import { Component, Injector, Input, OnInit } from '@angular/core';
import { DialogBaseComponent } from "../../base-admin-panel/dialog-base/dialog-base.component";
import { DriversService } from "../../../../services/drivers.service";
import { DriverPenaltyViewModel } from "../models/DriverPenaltyViewModel";


@Component({
  selector: 'app-penalty-dialog',
  templateUrl: './penalty-dialog.component.html',
  styleUrls: ['./penalty-dialog.component.css'],
  standalone: false
})
export class PenaltyDialogComponent extends DialogBaseComponent<DriverPenaltyViewModel> implements OnInit {
  public openedTabName: string = "main";

  @Input()
  protected service: DriversService;

  constructor(protected injector: Injector) {
    super(injector);
    this.service = injector.get(DriversService);
    this.dialogId = "penaltydialog";
  }

  ngOnInit() {
  }

  public openTab(name: string) {
    this.openedTabName = name;
  }

  public isSelected(name: string) {
    return name == this.openedTabName;
  }

  show(id: number) {
    this.model = new DriverPenaltyViewModel();
  }


  open(model: DriverPenaltyViewModel, type: { new(): DriverPenaltyViewModel } = undefined) {
    super.open(model, type);
  }
  public submit() {
    this.service.updatePenalty(this.model).subscribe((res) => {
      this.close();
      this.syncService.NotifyEntityChanged("DriverPenalty", 0);
      super.submit();
    });
  }
}
